'use client';

import { createContext, useState, useContext, useMemo } from 'react';

// Create a context for our ReactQueryRestore state
type ReactQueryRestoreContextType = {
  isAllLoaded: boolean;
  setIsAllLoaded: (isAllLoaded: boolean) => void;
};

const ReactQueryRestoreContext = createContext<
  ReactQueryRestoreContextType | undefined
>(undefined);

// Create a provider component
function ReactQueryRestoreProvider({ children }: React.PropsWithChildren) {
  const [isAllLoaded, setIsAllLoaded] = useState(false);

  return (
    <ReactQueryRestoreContext.Provider
      value={useMemo(
        () => ({
          isAllLoaded,
          setIsAllLoaded,
        }),
        [isAllLoaded]
      )}
    >
      {children}
    </ReactQueryRestoreContext.Provider>
  );
}

// Create a custom hook to use the ReactQueryRestore context
function useReactQueryRestore() {
  const context = useContext(ReactQueryRestoreContext);
  if (context === undefined) {
    throw new Error(
      'useReactQueryRestore must be used within a ReactQueryRestoreProvider'
    );
  }
  const { isAllLoaded, setIsAllLoaded } = context;

  return {
    isAllLoaded,
    setIsAllLoaded,
  };
}

export { ReactQueryRestoreProvider, useReactQueryRestore };
